import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  template: `
    @if (data.showButton) {
      <div class="text-center">
        @if (!loading) {
          <p (click)="clickButton()" class="btn m-0 action-btn" [ngClass]="data.class" [nbTooltip]="data.tooltip" nbTooltipStatus="default" nbTooltipPlacement="bottom">
            {{ data.label }} <nb-icon [icon]="data.icon"></nb-icon>
          </p>
        }
        @if (loading) {
          <i class="fa fa-spinner fa-spin"></i>
        }
      </div>
    }
    `,
  styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent implements OnInit {
  _data: any;
  loading = false;

  constructor() {}

  ngOnInit(): void {
    this.loading = this.data.loading;
  }

  @Input()
  set data(value: any) {
    this._data = value;
    this.loading = this.data.loading;
  }
  
  get data(): any {
    return this._data;
  }

  clickButton() {
    event.preventDefault();
    event.stopPropagation();
    if (this.data?.confirmAction) {
      this.loading = true;
      this.data.confirmAction(() => this.data.action(this.data.id), () => {
        this.loading = false;
      });
    } else {
      if (this.data?.action) {
        this.loading = true;
        this.data.action(this.data.id, () => {
          this.loading = false;
        });
      }
    }
  }
}
